/**
 * JPH client side Spray Vision
 */
import { CollapseButton } from "./collapse";
import { OADForm } from "./oad_tools";
var SprayVision = /** @class */ (function () {
    function SprayVision(results, todayHour) {
        var _this = this;
        /* Pour gérer le changement de quadran par la suite */
        this.quadranPosition = 0;
        this.hourCode = "";
        this.clr = "";
        this.bad = "";
        this.msg = "";
        this.mcode = "";
        this.objresults = JSON.parse(results);
        if (todayHour < 13) {
            this.hourCode = "AM" + todayHour;
        }
        else {
            this.hourCode = "PM" + todayHour;
        }
        /* add all events on SVG quadrants */
        var buttons = Array.from(document.getElementsByTagName("path"));
        buttons.forEach(function (btn) {
            btn.addEventListener("click", function (event) {
                _this.selectSVG("" + btn.getAttribute("quadrant"), "" + btn.getAttribute("hourcode"));
            });
        });
    }
    /* Set colors of dial */
    SprayVision.prototype.initSVG = function () {
        var data = this.objresults;
        for (var i = 1; i < 4; i++) {
            var refQuadri = "Q" + i;
            var quadri = document.getElementById(refQuadri);
            var refData = "Q" + (i + this.quadranPosition);
            /* Date du quadran */
            var dateObject = (quadri.getElementsByClassName("dateSpan"));
            var dateData = new Date(data[refData].date);
            dateObject[0].innerText =
                dateData.getDate() +
                    "-" +
                    (dateData.getMonth() + 1) +
                    "-" +
                    dateData.getFullYear();
            for (var heure in data[refData].heures) {
                var dial = quadri.getElementsByClassName(heure);
                dial[0].classList.remove("disabled");
                dial[0].classList.add(data[refData].heures[heure][this.clr]);
                var pluDial = quadri.getElementsByClassName("P" + heure);
                var pluBoolean = data[refData].heures[heure].plu === "true";
                if (pluBoolean) {
                    if (pluDial[0].classList.contains("PAM12")) {
                        quadri.getElementsByClassName("AM")[0].classList.add("hidden");
                    }
                    if (pluDial[0].classList.contains("PPM24")) {
                        quadri.getElementsByClassName("PM")[0].classList.add("hidden");
                    }
                    pluDial[0].classList.remove("hidden");
                }
            }
        }
    };
    /* Set variable name */
    SprayVision.prototype.initVariablesNames = function () {
        var data = this.objresults;
        for (var variable in data["Q1"].heures[Object.keys(data["Q1"].heures)[0]]) {
            if (variable.includes("bad")) {
                this.bad = variable;
            }
            if (variable.includes("clr")) {
                this.clr = variable;
            }
            if (variable.includes("msg")) {
                this.msg = variable;
            }
            if (variable.includes("mcode")) {
                this.mcode = variable;
            }
        }
    };
    /* Reinit other quadran data to hidden */
    SprayVision.prototype.reinitQuadri = function () {
        var quadriObject = document.getElementsByClassName("hours");
        for (var i = 0; i < quadriObject.length; i++) {
            for (var a = 0; a < quadriObject[i].children.length; a++) {
                quadriObject[i].children[a].classList.remove("selected");
            }
        }
        var messageTitleObject = document.getElementById("pulve-title");
        messageTitleObject.classList.remove("optimale");
        messageTitleObject.classList.remove("correcte");
        messageTitleObject.classList.remove("limite");
        messageTitleObject.classList.remove("deconseillee");
        messageTitleObject.classList.remove("interdite");
        var iconsObject = document.getElementsByClassName("bad");
        for (var i = 0; i < iconsObject.length; i++) {
            for (var a = 0; a < iconsObject[i].children.length; a++) {
                iconsObject[i].children[a].classList.add("hidden");
            }
        }
        var hourObject = document.getElementsByClassName("hourSpan");
        for (var i = 0; i < hourObject.length; i++) {
            hourObject[i].classList.add("hidden");
        }
    };
    /* Adapt info with selected element */
    SprayVision.prototype.selectSVG = function (refQuadri, time) {
        this.reinitQuadri();
        var data = this.objresults;
        var refData = "Q" + (parseInt(refQuadri.substring(1)) + this.quadranPosition);
        var info = data[refData].heures[time];
        /* gestion du SVG actif */
        var quadri = document.getElementById(refQuadri);
        var dial = quadri.getElementsByClassName(time);
        dial[0].classList.add("selected");
        /* gestion du conseil */
        var messageObject = document.getElementById("pulve-message");
        var messageTitleObject = document.getElementById("pulve-title");
        var codeObject = document.getElementById("pulve-mcode");
        if (info != undefined) {
            messageObject.innerText = decodeURIComponent(info[this.msg]);
            messageTitleObject.classList.add(info[this.clr]);
            codeObject.innerText = decodeURIComponent(info[this.mcode]);
        }
        else {
            messageObject.innerText = "Pas de données sur cette période";
        }
        /* gestion heure cadran */
        var hourObject = (quadri.getElementsByClassName("hourSpan"));
        hourObject[0].classList.remove("hidden");
        var dialPick = time.substring(2);
        hourObject[0].innerText = dialPick + "h";
        /* gestion icones */
        var listeObject = (quadri.getElementsByClassName("bad"));
        listeObject[0].classList.remove("hidden");
        var childrenUl = listeObject[0].childNodes;
        if (info != undefined) {
            for (var i = 0; i < childrenUl.length; i++) {
                var myelement = childrenUl[i];
                if (myelement.localName == "li") {
                    for (var x = 0; x < myelement.classList.length; x++) {
                        myelement.classList.add("hidden");
                        if (myelement.classList[x] == info[this.bad]) {
                            myelement.classList.remove("hidden");
                        }
                    }
                }
            }
        }
    };
    return SprayVision;
}());
// window.ontouchmove = scrollAdvice();
function scrollAdvice() {
    console.log(document.documentElement.scrollTop);
    if (document.documentElement.scrollTop > 50) {
        document.getElementById("scrollAdvice").className = "test";
    }
}
window.addEventListener("ontouchmove", function (e) {
    var distanceY = window.pageYOffset;
    if (distanceY > 0) {
        console.log(distanceY);
    }
    scrollAdvice();
});
// $("window").on("touchmove", function (event) {
//   event.preventDefault();
//   var distanceY = window.pageYOffset;
//   if (distanceY > 0) {
//     console.log(distanceY);
//   }
// });
window.onload = function () {
    /* Au chargement de la page*/
    results = results.replace(/&#x27;/g, "'").replace(/&quot;/g, '"');
    if (results.length > 0) {
        var today = new Date();
        var myinstance = new SprayVision(results, today.getHours());
        myinstance.initVariablesNames();
        myinstance.initSVG();
        myinstance.selectSVG("Q1", myinstance.hourCode);
    }
    //load collapse button
    var btnCollapse = new CollapseButton();
    //load OADForm widgets
    var oad_form = new OADForm();
};
